import type { UseFormReturn } from 'react-hook-form';
import { CategoryTransactionSection } from './CategoryTransactionSection';
import { AddressSection } from './AddressSection';
import { AreasValuesSection } from './AreasValuesSection';
import { CharacteristicsSection } from './CharacteristicsSection';
import { AmenitiesSection } from './AmenitiesSection';
import type { PropertyFormValues } from './schema';

interface DadosTabProps {
  form: UseFormReturn<PropertyFormValues>;
  onCepBlur: (cep: string) => void;
  agencyId: string;
  /** The property under edit, when editing. */
  propertyId?: string;
}

/**
 * Renders the property structural data sections (category, address,
 * areas/values, characteristics, amenities) in a single vertical column.
 * On desktop the parent shell arranges this column beside the publication
 * and operations column via its own responsive grid.
 */
export function DadosTab({ form, onCepBlur, agencyId, propertyId }: DadosTabProps) {
  return (
    <div className="flex flex-col gap-(--space-6)">
      <CategoryTransactionSection form={form} />
      <AddressSection form={form} onCepBlur={onCepBlur} agencyId={agencyId} propertyId={propertyId} />
      <AreasValuesSection form={form} />
      <CharacteristicsSection form={form} />
      <div data-drawer-section="amenities">
        <AmenitiesSection form={form} />
      </div>
    </div>
  );
}
